import { Icon } from '@ztechapps/webui.util'
import React from 'react'

export const PhoneNumberLink = ({ className }: any) => {
  return (
    <a href="tel:8889597395" className={className}>
      <Icon name="phone" /> 888-959-7395
    </a>
  )
}
